<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("Raw Material Supplier Wise Cost Report") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="selectedVendor && selectedVendor.length ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("vendor") }}</label
              >
              <multiselect
                :options="vendorsData"
                 :multiple="true"
                 deselect-label="Remove"
                v-model="selectedVendor"
                :searchable="true"
                label="v_name"
                track-by="v_id"
                placeholder="Select Vendor"
                 :allow-empty="true"
                 :close-on-select="false"
              ></multiselect>
            </div>
          </div>
                    <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="selectedRawMaterial && selectedRawMaterial.length ? 'shift-up' : ''"
                >Select Raw Material</label
              >
              <multiselect
                :options="rawMaterialList"
                v-model="selectedRawMaterial"
                :searchable="true"
                label="rm_name"
                track-by="rm_id"
                placeholder="Select Raw Material"
                :allow-empty="true"
               :multiple="true"
                 deselect-label="Remove"
                 :close-on-select="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-1 align-self-center mb-3">
            <button
              class="btn-blue-lg"
              @click.prevent="getRawMaterialsCostReport({isPdf:'N',isExcel:'N'})"
              style="min-width: 85px !important;"
              >
              {{ $t("fetch") }}
              <!-- {{ $t("report") }} -->
            </button>
          </div>

          <div
            v-if="rawMaterialCostRecords.length > 0"
            class="col-lg-6 col-xl-9 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->
            <a
              href="#"
              @click="getRawMaterialsCostReport({isPdf:'Y',isExcel:'N'})"
              title="Download as Pdf"
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf.svg"
                height="25"
                width="25"
              />
            </a>
            <a
              href="#"
              @click="getRawMaterialsCostReport({isPdf:'N',isExcel:'Y'})"
              title="Download as Excel"
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>
      <div
        style="overflow-x:scroll;width: auto !important"
        ref="exportable_table"
      >
        <table class="swc-report-table" border="1">
          <tr class="bg-lightgrey font-weight-bold">
                        <!-- <th>Supplier</th> -->

            <!-- <th>Book Name</th> -->
            <!-- <th>Branch</th> -->
            <th>Item Name(Raw Material)</th>
            <th>UOM</th>
            <th>Supply date</th>
            <th>Cost Price(SAR)</th>
          </tr>
          <tbody v-if="rawMaterialCostRecords && rawMaterialCostRecords.length">
            <template 
             v-for="(vendor,
              vendorIndex) in rawMaterialCostRecords"
            >
            <tr  class="bg-lightgrey font-weight-bold"><td class='' colspan="5">{{vendor.v_name}}</td></tr>
            <template 
             v-for="(cinema,
              cinemaIndex) in vendor.vendorData"
            > 
            <template
            v-for="(rawMaterial,
              rawMaterialIndex) in cinema.cinemaData"
            >
            <tr>
              <!-- <td class="text-left" :rowspan="rawMaterial.rawMaterialData.length+1">{{ cinema.cinema_name }}</td> -->
              <td class="text-left"  :rowspan="rawMaterial.rawMaterialData.length+1">{{ rawMaterial.rm_name }}</td>
            </tr>
            <tr
             v-for="(rawMaterialCostData,
              rawMaterialCostIndex) in rawMaterial.rawMaterialData"
            >
            <!-- <td class="text-left" >
                  {{ rawMaterialCostData.cine_name ||"-"}}
            </td>
            <td class="text-left">
              {{ rawMaterialCostData.rm_name || "-"}}
            </td> -->
            <td class="text-left">{{ rawMaterialCostData.uom_unit || "-"}}</td>
            <td class="text-left">{{ rawMaterialCostData.supply_date ||"-" }}</td>
            <td class="text-right">{{ currFormat(rawMaterialCostData.single_rate ||0) }}</td>
          </tr>
            </template>

            </template>
            <!-- <tr><td colspan="5"></td></tr> -->
            </template>
          
          </tbody>
          <tbody v-if="!rawMaterialCostRecords || !rawMaterialCostRecords.length">
            <tr><td colspan="5" class="text-center">No Records</td></tr>
          </tbody>
        </table>
      </div>
    
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: ""
      },
      fromDate: new Date(),
      toDate: new Date(),
      vendorsData: [],
      rawMaterialList:[],
      rawMaterialCostRecords: [],
      selectedVendor:[],
      selectedRawMaterial:[],
      searchValue:""
    };
  },
  computed: {
    vendorIds() {
      let text = ``;
      if (this.selectedVendor.length > 0) {
        text = this.selectedVendor.map((x) => x.v_id).join(",");
      }

      return text;
    },
    rawMaterialIds() {
      let text = ``;
      if (this.selectedRawMaterial.length > 0) {
        text = this.selectedRawMaterial.map((x) => x.rm_id).join(",");
      }

      return text;
    },
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    // if (CinemaObj) {
    //   this.onSelectCinema(CinemaObj);
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(CinemaObj);
    //   }
    // }
  },
  mounted() {
    this.getVendorsList();
    this.getRawMaterialList();
  },
  methods: {
    onChangeDate: function(e, type){
      if(type == 'from'){
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    moment,
    ExportExcel(type, fn, dl) {
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, {
        sheet: `RawMaterialSupplierWise`
      });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(
            wb,
            fn ||
              `RawMaterialSupplierWiseCost-${
                this.dropDown.selectedCinemaName
              }.${type || "xlsx"}`
          );
    },
    getCinemaList: function() {
      MasterService.GetCinemasByRoles()
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function(event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getVendorsList() {
      let loader = this.$loading.show();

      let payload = {
        tableName: "ms_vendors",
        v_is_active: "Y"
      };
      MasterService.GetActiveList(payload).then(response => {
        const { data } = response;

        if (data.status && data.Records.length > 0) {
          this.vendorsData = data.Records.sort((a, b) => {
        if (a.v_name.toLowerCase() < b.v_name.toLowerCase()) return -1;
        if (a.v_name.toLowerCase() > b.v_name.toLowerCase()) return 1;
        return 0;
      });
          loader.hide();
        } else {
          this.$toasted.show(data.message);
        }
      });
    },
    getRawMaterialList() {
      let loader = this.$loading.show();

      let payload = {
        tableName: "ms_raw_materials",
        rm_is_active: "Y"
      };
      MasterService.GetActiveList(payload).then(response => {
        const { data } = response;

        if (data.status && data.Records.length > 0) {
          this.rawMaterialList = data.Records.sort((a, b) => {
      if (a.rm_name.toLowerCase() < b.rm_name.toLowerCase()) return -1;
      if (a.rm_name.toLowerCase() > b.rm_name.toLowerCase()) return 1;
      return 0;
    });
          loader.hide();
        } else {
          this.$toasted.show(data.message);
        }
      });
    },
    getRawMaterialsCostReport({isPdf="N",isExcel="N"}) {
      this.rawMaterialCostRecords = [];
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        rm_id:this.rawMaterialIds,
        v_id:this.vendorIds,
        // search_value: this.selectedVendor ? this.selectedVendor.v_name : "",
        excel: isExcel,
        isPdf
      };
      ReportsService.GetRawMaterialSupplierWise(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.rawMaterialCostRecords = [...data.Records];
            if (isExcel == "Y") {
              window.open(data.excelPath);
            }
            if(isPdf=="Y" && data.pdfPath){
              window.open(data.pdfPath,"_blank");
            }
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    }
  }
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}
.swc-report-table td {
  white-space: nowrap;
}
.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/rawMaterialSupplierWiseReport.vue